module.exports = __webpack_public_path__ + "media/packs/src/assets/images/add-lesson-note-icon.svg-becaa0afc2d7cc1e4c4b1dd3578e2364.svg";